import { render } from "./BookingDetailPage.vue?vue&type=template&id=d6fea092&scoped=true"
import script from "./BookingDetailPage.vue?vue&type=script&lang=ts"
export * from "./BookingDetailPage.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-d6fea092"

export default script